// https://app.growthbook.io/features/prcng-955_v1
export const PLAN_Z_BOGO_FLAG_NAME = 'prcng-955_v1'
